import { CollaboratorRosterAllResponse, RosterCardAllResponse, RosterPeriodAllResponse } from "app/types/nomina";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_NET;

export async function getAllRosterPeriods(page: number | string, pageSize: number | string) {
  try {
    const response = await axios.get<RosterPeriodAllResponse>(`${API_URL}Roster/GetRosterPeriod?page=${page}&pageSize=${pageSize}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching Roster Periods:", error);
    throw error;
  }
}

export async function getAllRosterCards(page?: number | string, pageSize?: number | string) {
  try {
    const response = await axios.get<RosterCardAllResponse>(`${API_URL}Roster/GetRosterCard?page=${page}&pageSize=${pageSize}`);
    return response.data.data;
  } catch (error) {
    // console.error("Error fetching Roster Cards:", error);
    throw error;
  }
}

export async function getLastRecord() {
  try {
    let response;
    response = await axios.get<RosterCardAllResponse>(`${API_URL}Roster/GetRosterCard`);
    const lastRecord = response.data.data.records[response.data.data.records.length - 1];
    return lastRecord;
  } catch (error) {
    // console.error("Error fetching Roster Cards:", error);
    throw error;
  }
}

export async function getAllCollaboratorRoster(periodId: number, page: number | string, pageSize: number | string) {
  if (periodId) {
    try {
      const response = await axios.get<CollaboratorRosterAllResponse>(`${API_URL}Roster?PeriodId=${periodId}&Page=${page}&PageSize=${pageSize}`);
      return response.data.data;
    } catch (err) {
      // console.error("Error fetching Roster Cards:", err);
      // throw err;
    }
  }
}

export const getCollaboratorRosterName = async (periodId: number | string, page: number | string, pageSize: number | string, employeeName?: string) => {
  try {
    const response = await axios.get(`${API_URL}Roster?PeriodId=${periodId}&EmployeName=${employeeName}&Page=${page}&PageSize=${pageSize}`);
    console.log(response)
    return response.data.data;
  } catch (err) {
    // console.error("Error fetching filter info ", err)
    // throw err;
  }
}